import { entryFactory } from 'factories';
import { OptionCollect, Reason, ReturnEntries, ReturnEntry } from 'types';

function populateReasons(reasons: any = []): Reason[] {
  return reasons.map((reason: any = {}): Reason => {
    const { code, additionalReasons = [], title } = reason;

    const hasSubReturnReasons = additionalReasons.length;

    return {
      code: code || '',
      additionalReasons: hasSubReturnReasons
        ? populateReasons(additionalReasons)
        : [],
      title: title || '',
    };
  });
}

function populateEntriesData(entriesData: any = []): ReturnEntry[] {
  return entriesData.map((entryData: any) => {
    const { entry, reasons } = entryData;

    return {
      entry: entryFactory(entry),
      reasons: populateReasons(reasons),
    };
  });
}

function populateOptionsCollect(optionsCollectData: any = []): OptionCollect[] {
  return optionsCollectData.map((optionCollect: any = {}): OptionCollect => {
    const { code, title, type } = optionCollect;

    return {
      code: code || '',
      title: title || '',
      type: type || '',
    };
  });
}

export function returnEntriesFactory(params: any = {}): ReturnEntries {
  const { consignmentCode, entries, optionsCollect } = params;

  return {
    consignmentCode: consignmentCode || '',
    entries: populateEntriesData(entries),
    optionsCollect: populateOptionsCollect(optionsCollect),
  };
}
